import { render, staticRenderFns } from "./DialogInfoTipoAssinatura.vue?vue&type=template&id=5fc7a52f"
import script from "./DialogInfoTipoAssinatura.vue?vue&type=script&lang=js"
export * from "./DialogInfoTipoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./DialogInfoTipoAssinatura.vue?vue&type=style&index=0&id=5fc7a52f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports